import React, { useState } from 'react';
import { Card, Avatar, Switch, Spin, Tag, Space, Tooltip, Dropdown, Button, Menu } from 'antd';
import { UserOutlined, EllipsisOutlined, EyeOutlined, EditOutlined, KeyOutlined } from '@ant-design/icons';
import { firestore } from "../../firebase"; 
import { useNotification } from '../NotificationContext';
import { useAuth } from "../Context";
import { auth } from "../../firebase";
import auditedServices from '../../servicios/empleados/serviciosAudit';
const { actualizarEstatus } = auditedServices;

const Empleado = ({ employee, onVerDetalle, onEditar, onCambiarPassword }) => {
  const { nombre, ap_paterno, edad, puesto, fecha_ingreso, celular, fotoUrl, estatus, areas } = employee;
  const { role, currentUser, isAdmin } = useAuth();
  // Solo el usuario autenticado con rol admin o puesto Gerente General puede ver el botón
  const puedeCambiarPassword = isAdmin || (role === 'Gerente General');
  const [updating, setUpdating] = useState(false);
  const openNotificationWithIcon = useNotification();
  const { sucursal } = useAuth();
  
  const handleToggleStatus = async (employee) => {
    setUpdating(true);
    try {
      const updatedStatus = employee.estatus === 'Activo' ? 'Inactivo' : 'Activo';
  // ...
      const body = {
        uid: employee.id,
        sucursal,
        estatus: updatedStatus
      }
      const validatedToken = await auth.currentUser.getIdToken(true);
      const response = await actualizarEstatus(validatedToken, body);
      if (response.success) {
        await firestore.collection('sucursal/Centro/empleado').doc(employee.id).update({ estatus: updatedStatus });
        openNotificationWithIcon(
          "success",
          "Información actualizada",
          "Se " + updatedStatus + " " + employee.nombre
        );
      } else {
        openNotificationWithIcon(
          "warning",
          "Algo salió mal",
          response.error.msg ? response.error.msg : response.error
        );
      }
    } catch (error) {
        openNotificationWithIcon(
          "error",
          "Error",
          "Error al actualizar el estado del empleado"
        );
      console.error("Error updating employee status: ", error);
    }
    setUpdating(false);
  };

  return (
    <Card
      style={{ borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2', minHeight: 340, maxHeight: 340, height: 340, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
      bodyStyle={{ padding: 18, paddingTop: 32, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}
      hoverable
    >
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        {updating ? <Spin /> :
          <Tooltip title={estatus === 'Activo' ? 'Desactivar' : 'Activar'}>
            <Switch
              checked={estatus === 'Activo'}
              onChange={() => handleToggleStatus(employee)}
              checkedChildren="Activo"
              unCheckedChildren="Inactivo"
              style={{ background: estatus === 'Activo' ? '#52c41a' : '#fa541c' }}
            />
          </Tooltip>
        }
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, flex: 1, justifyContent: 'center' }}>
        <Avatar size={64} icon={<UserOutlined />} src={fotoUrl} style={{ marginBottom: 8 }} />
        <h3 style={{ margin: 0, fontWeight: 600, textAlign: 'center', maxWidth: 160, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{nombre} {ap_paterno}</h3>
        <Tag color={estatus === 'Activo' ? 'green' : 'volcano'} style={{ marginBottom: 4 }}>{estatus}</Tag>
        <Space direction="vertical" size={0} style={{ width: '100%' }}>
          <span style={{ display: 'block', maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Puesto:</b> {puesto}</span>
          <span style={{ display: 'block', maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Fecha de Ingreso:</b> {fecha_ingreso}</span>
          <span style={{ display: 'block', maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Teléfono:</b> {celular}</span>
          <span style={{ display: 'block', maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Edad:</b> {edad}</span>
          {areas && Array.isArray(areas) && areas.length > 0 && (
            <span style={{ display: 'block', maxWidth: 180, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><b>Áreas:</b> {areas.map(area => <Tag key={area}>{area}</Tag>)}</span>
          )}
          <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'center' }}>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key="detalle" icon={<EyeOutlined />} onClick={() => onVerDetalle && onVerDetalle(employee)}>
                    Ver Detalle
                  </Menu.Item>
                  <Menu.Item key="editar" icon={<EditOutlined />} onClick={() => onEditar && onEditar(employee)}>
                    Editar
                  </Menu.Item>
                  {puedeCambiarPassword && (
                    <Menu.Item key="cambiarPassword" icon={<KeyOutlined />} onClick={() => onCambiarPassword && onCambiarPassword(employee)}>
                      Cambiar contraseña
                    </Menu.Item>
                  )}
                </Menu>
              }
              trigger={['click']}
            >
              <Button icon={<EllipsisOutlined />} shape="circle" />
            </Dropdown>
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default Empleado;
